#import "../company/companyInfo.gql"
#import "../site/siteInfo.gql"
#import "../timeZone/timeZoneInfo.gql"
#import "../user/userInfo.gql"
#import "../customerSettings/customerSettingsInfo.gql"

query GetApplicationContext {
  applicationContext {
    user {
      userPreferences {
        extendedView
      }
      ...userInfo
    }
    role
    nulogyAdmin
    nulogyRestricted
    nulogyUser
    site {
      ...siteInfo
    }
    settings
    customerSettings {
      ...customerSettingsInfo
    }
    timeZone {
      ...timeZoneInfo
    }
    company {
      ...companyInfo
    }
    packmanagerUrl
    trainingMode
    pendoEnabled
    branch
  }
}
